import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLanguage } from './LanguageContext';
import translations from '../translations.json';
import './Trust.css';

const TrustUs: React.FC = () => {
  const { language } = useLanguage();
  const t = translations[language]['trust'];

  return (
    <section className="trust">
      <Container className="d-flex align-items-center justify-content-center h-100">
        <Row className="justify-content-center">
          <Col md={8}>
            <h1 className="text-center" dangerouslySetInnerHTML={{ __html: t.title }} />
            <div className="deco-line rounded mx-auto my-5"></div>
            <p className="text-center" dangerouslySetInnerHTML={{ __html: t.description }} />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default TrustUs;
